import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { SchedulerSurgeons } from '@lp/features/Scheduler';
import {
  useHtLuSSchedulerData,
  useHtLuSSchedulerMutationActions,
  useHtLuSSchedulerServices,
  useHtLuSShiftChange,
  useHtLuSUnblockShift,
  useHtLuSWorkdaySync,
} from '@lp/features/Scheduler/SchedulerSurgeons/hooks';

type SchedulerHeartAndLungsSurgeonsProps = {
  readonly?: boolean;
  showSettings?: boolean;
};

export const SchedulerHeartAndLungsSurgeons = ({ readonly, showSettings }: SchedulerHeartAndLungsSurgeonsProps) => {
  return (
    <SchedulerSurgeons
      organGroup={SOrganGroup.HeartAndLungs}
      settingsPath="/schedule/s-htlu/settings"
      disableSettings={!showSettings}
      readonly={readonly}
      useSSchedulerData={useHtLuSSchedulerData}
      useSSchedulerMutationActions={useHtLuSSchedulerMutationActions}
      useSSchedulerServices={useHtLuSSchedulerServices}
      useSShiftChange={useHtLuSShiftChange}
      useSUnblockShift={useHtLuSUnblockShift}
      useSWorkdaySync={useHtLuSWorkdaySync}
    />
  );
};
